(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root['@readcube/viewer-preview-web'] = factory();
  }
}(typeof self !== 'undefined' ? self : this, function() {

  function ViewerPreviewWeb({ container, origin, events }) {
    let api = {};
    let frame = null;
    let onMessage = null;

    function params(hash) {
      const arr = [];
      for (let key in hash) {
        hash[key] && arr.push(key + '=' + encodeURIComponent(hash[key]));
      }
      return arr.join('&');
    }

    function addParams(url, hash) {
      url += (url.indexOf('?') == -1) ? '?' : '&';
      url += params(hash);
      return url;
    }

    function frameSrc({ collectionId, itemId, types }) {
      origin = origin || 'https://www.readcube.com';
      const url = `${origin}/resolve/${collectionId}:${itemId}`;
      return addParams(url, { types });
    }

    function hideFrame() {
      if (!frame) return;
      frame.style.visibility = 'hidden';
      frame.style.pointerEvents = 'none';
      frame.style.zIndex = -1;
    }

    function showFrame() {
      if (!frame) return;
      frame.style.visibility = 'visible';
      frame.style.pointerEvents = 'auto';
      frame.style.zIndex = 1000;
    }

    function createFrame() {
      if (frame && frame.parentNode) {
        frame.parentNode.removeChild(frame);
      }

      frame = document.createElement('iframe');
      frame.id = 'preview-frame';
      frame.setAttribute('seamless', '');
      frame.setAttribute('allowTransparency', 'true');
      frame.style.position = 'absolute';
      frame.style.height = '100%';
      frame.style.width = '100%';
      frame.style.backgroundColor = 'transparent';
      frame.style.border = '0px none transparent';
      frame.style.padding = '0px';
      frame.style.overflow = 'hidden';

      hideFrame();

      container.appendChild(frame);
    }

    function bindOnMessage(onInit) {
      return e => {
        const msg = e.data;
        switch (msg.type) {
          case 'initialized':
            showFrame();
            onInit();
            return;
          case 'marked':
            if (events.mark) events.mark(e, msg.data.type, msg.data.text);
            return;
          case 'title-found':
            if (events.title) events.title(e, msg.data.title);
            return;
          case 'preview-unavailable':
            if (events.unavailable) events.unavailable(e);
            return;
        }
      }
    }

    function loadFrame({ collectionId, itemId, types }) {
      return new Promise(resolve => {
        if (onMessage) {
          window.removeEventListener('message', onMessage)
        }

        onMessage = bindOnMessage(resolve);
        window.addEventListener('message', onMessage, false);

        createFrame();
        frame.setAttribute('src',
          frameSrc({ collectionId, itemId, types }));
      });
    }

    function render({ collectionId, itemId, types }) {
      return loadFrame({ collectionId, itemId, types }).then(() => api);
    }

    function find(query) {
      if (frame) {
        frame.contentWindow.postMessage({ type: 'find', query }, '*');
      }
    }

    function destroy() {
      if (onMessage) {
        window.removeEventListener('message', onMessage)
        onMessage = null;
      }
      if (frame && frame.parentNode) {
        frame.parentNode.removeChild(frame);
        frame = null;
      }
    }

    api.render = render;
    api.find = find;
    api.destroy = destroy;

    return api;
  }

  return ViewerPreviewWeb;
}));
